import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Inject, PLATFORM_ID } from "@angular/core";
import { Router } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class DataSharingService {
  isNew: any;
  private languageSource = new BehaviorSubject<string>("No language");

  public isLoginChanged: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public isProfileChanged: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  public isHelpnotification: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public helpPage: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public userAvatar: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public searchParam: BehaviorSubject<any> = new BehaviorSubject<any>("");
  public searchEmpty: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public notificationHeader: BehaviorSubject<boolean> =
    new BehaviorSubject<any>(false);
  public notificationPage: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public notificationData: BehaviorSubject<boolean> = new BehaviorSubject<any>(
    null
  );
  public newMessageRecive: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public clearNotification: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public showSideBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );
  public showManageSideBar: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  private storage: any;
  currentLanguage = this.languageSource.asObservable();

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private router: Router
  ) {
    this.storage = localStorage;
  }

  // --- helpers ---

  private normalize(url: string): string {
    if (!url || !url.startsWith("/") || url.startsWith("//")) return "";
    return url;
  }
  private isAllowed(url: string): boolean {
    const u = this.normalize(url);
    if (!u) return false;
    if (
      u.startsWith("/auth") ||
      u.startsWith("/onboarding") ||
      u.startsWith("/introduction")
    )
      return false;
    return true;
  }

  private readAllowedReturnUrl(): string | null {
    if (!isPlatformBrowser(this.platformId)) return null;
    const fromSS = sessionStorage.getItem("returnUrl");
    const fromLS = localStorage.getItem("returnUrl");
    const pick = fromSS || fromLS || "";
    return this.isAllowed(pick) ? pick : null;
  }
  private consumeAllowedReturnUrl(): string | null {
    const u = this.readAllowedReturnUrl();
    if (u) {
      try {
        sessionStorage.removeItem("returnUrl");
        localStorage.removeItem("returnUrl");
      } catch { }
    }
    return u;
  }
  languageChange(data) {
    this.languageSource.next(data);
  }

  getItem(key: string): string | null {
    return this.storage.getItem(key);
  }

  setItem(key: string, value: string): void {
    this.storage.setItem(key, value);
  }

  removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  clear(): void {
    localStorage.removeItem("accessInfo");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("appleData");
    localStorage.removeItem("fbData");
    localStorage.removeItem("googleData");
    localStorage.removeItem("onboarding-error");
    localStorage.setItem("language", "1");
  }

  setUserAvatar(value) {
    this.userAvatar.next(value);
  }

  passNotification(value) {
    this.notificationHeader.next(value);
  }

  searchFaq(query: string) {
    this.searchParam.next(query);
  }
  setLocalData(allData) {
    const data = {
      name: allData.name,
      email: allData.email,
      gender: allData.gender,
      isCompleteProfile: allData.isCompleteProfile,
      isApproved: allData.isApproved,
      webFinished: allData.webFinished,
      saloonRole: allData.saloonRole,
      businessProfile: allData.businessProfile,
      profileImage: allData.profileImage,
      teamSize: allData.teamSize,
      ServiceProviderSessions: allData.ServiceProviderSessions,
      notificationEnabled: allData.notificationEnabled,
      registrationVia: allData.registrationVia,
      isEmailVerified: allData.isEmailVerified,
      isPhoneVerified: allData.isPhoneVerified,
      phoneNumber: allData.phoneNumber,
      countryCode: allData.countryCode,
    };
    localStorage.setItem("language", allData?.language);
    localStorage.setItem("userInfo", JSON.stringify({ userDetails: data }));
  }
  setBusniess(allData) {
    let localDatas = JSON.parse(localStorage.getItem("userInfo") || "");
    localDatas["userDetails"].businessProfile = allData.businessProfile;
    localStorage.setItem("userInfo", JSON.stringify(localDatas));
  }

  preventBackButton() { }

  redirection(data, type) {
    if (data) {
      if (data?.isCompleteProfile == 0) {
        if (type == "email") {
          sessionStorage.setItem("language", data.email);
          sessionStorage.setItem("email", data.email);
        } else {
          sessionStorage.setItem(
            "phone",
            data.countryCode + "-" + data.phoneNumber
          );
        }
        sessionStorage.setItem(
          "dummyAccess",
          data?.ServiceProviderSessions?.accessToken
        );

        const googleData = localStorage.getItem("googleData");

        if (googleData) {
          this.router.navigate(["/auth/create-account"]);
        } else {
          this.router.navigate(["/auth/signin"]);
        }
      } else if (
        data.isCompleteProfile == 1 &&
        data?.ServiceProviderSessions?.accessToken &&
        data.saloonRole == 1 &&
        data.isApproved == 0
      ) {
        this.setLocalData(data);
        this.router.navigateByUrl("/introduction");
      } else if (
        data.isCompleteProfile == 1 &&
        data.businessProfile?.getBusinessProfile == null &&
        data.ServiceProviderSessions?.accessToken &&
        data.saloonRole == 1 &&
        data.isApproved == 0
      ) {
        this.router.navigate(["/introduction"]);
      } else if (
        data.isCompleteProfile == 1 &&
        data.businessProfile?.getBusinessWorkExp == null &&
        data.ServiceProviderSessions?.accessToken &&
        data.saloonRole == 1 &&
        data.isApproved == 0
      ) {
        this.router.navigate(["/introduction"]);
      } else if (
        data.isCompleteProfile == 1 &&
        data.businessProfile?.getPortfolio.length != 0 &&
        data.ServiceProviderSessions?.accessToken &&
        data.saloonRole == 1 &&
        (data.isApproved == 0 || data.isApproved == 4)
      ) {
        this.router.navigate(["/review-error"]);
      } else if (
        data.isCompleteProfile == 1 &&
        data.isApproved == 1 &&
        data.saloonRole == 1
      ) {
        this.router.navigate(["/in-review"]);
      } else if (
        data.isCompleteProfile == 1 &&
        data.isApproved == 2 &&
        data.webFinished == 0
      ) {
        this.router.navigate(["/review-completed"]);
      } else if (
        data.isCompleteProfile == 1 &&
        data.isApproved == 2 &&
        data.webFinished == 1
      ) {
        const ret = this.consumeAllowedReturnUrl();
        const currentUrl = this.router.url;
        const authRoutes = ["/auth/signin", "/login", "/auth/create-account"];
        const isAuthRoute = authRoutes.some(route => currentUrl.startsWith(route));

        if (ret) {
          this.router.navigateByUrl(ret);
          return;
        }

        if (isAuthRoute) {
          this.router.navigate(["/dashboard"]);
          return;
        }

        return;
      }
      else if (
        data.isCompleteProfile == 1 &&
        data.isApproved == 2 &&
        data.webFinished == 1 &&
        data.saloonRole == 2
      ) {
        const ret = this.consumeAllowedReturnUrl();
        if (ret) this.router.navigateByUrl(ret);
        else this.router.navigate(["/dashboard"]);
      }
    }
  }
}
